import { api } from "../lib";

export interface PasskeyInfo {
  id: string;
  deviceName: string;
  registeredAt: string;
  lastUsedAt: string | null;
}

export const passkeyService = {
  getRegistrationOptions: async () => {
    return api.post<any>("/auth/passkey/register/options", {});
  },

  verifyRegistration: async (credential: any, deviceName: string) => {
    return api.post<PasskeyInfo>("/auth/passkey/register/verify", {
      credential,
      deviceName,
    });
  },

  getLoginOptions: async (username?: string) => {
    return api.post<any>("/auth/passkey/login/options", { username });
  },

  verifyLogin: async (
    username: string | undefined,
    credential: any,
    challengeKey?: string
  ) => {
    return api.post<any>("/auth/passkey/login/verify", {
      ...(username && { username }),
      ...(challengeKey && { challengeKey }),
      credential,
    });
  },

  listPasskeys: async (): Promise<PasskeyInfo[]> => {
    return api.get<PasskeyInfo[]>("/auth/passkeys");
  },

  removePasskey: async (id: string) => {
    return api.delete<void>(`/auth/passkeys/${id}`);
  },

  adminRevokePasskeys: async (userId: string) => {
    return api.delete<{ message: string; count: number }>(
      `/admin/users/${userId}/passkeys`
    );
  },
};
